export default {
      id: "ic_clock_schedule_time-usage",
      viewBox: "0 0 25 25",
      url: "/" + "images/icons.3.109.2.svg#ic_clock_schedule_time-usage",
      toString: function () {
        return this.url;
      }
    }